import React, { useContext } from "react";
import styled from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import { ServiceRequestContext } from "context/ServiceRequestContext";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const hoverDownloadCloud = `${CDN_URL}common/download-cloud-icon-hover-lg.svg`;
const downloadCloudSupport = `${CDN_URL}common/download-cloud-icon-support-lg.svg`;

const RulesScreenStyle = styled.div`
  .sign-button {
    margin-top: 10px;
  }
  a {
    margin-bottom: 10px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
  }
`;

export const RulesScreen = () => {
  const { change } = useContext(ServiceRequestContext);

  return (
    <RulesScreenStyle>
      <div className="ticket-sign">
        <a
          href={`/cdn/files/datacenter-rules.pdf`}
          download={`DataCenterRules.pdf`}
          aria-label={`DataCenterRules.pdf`}
        >
          <img
            id="dc-rules-download-button"
            src={hoverDownloadCloud}
            onMouseOver={(e) => {
              e.currentTarget.src = downloadCloudSupport;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = hoverDownloadCloud;
            }}
          />
        </a>

        <div className="labels22">
          Your guest will be required to review and sign the data center rules
          and regulations upon arrival.
        </div>
        <div className="sign-button">
          <BloxButton
            className="buttons41"
            id="okay"
            text="I UNDERSTAND"
            module="support"
            enabled={true}
            onClick={() => {
              change({ target: { name: "rulesAcknowledged", value: true } });
            }}
            cypressId="ga-accept-rules"
          />
        </div>
      </div>
    </RulesScreenStyle>
  );
};
